export enum EntityFlags {
  None = 0,
  Fly = 1 << 0,
  Swim = 1 << 1,
  ImmuneLaser = 1 << 2,
  InWater = 1 << 3,
  GodMode = 1 << 4,
  NoTarget = 1 << 5,
  ImmuneSlime = 1 << 6,
  ImmuneLava = 1 << 7,
  PartialGround = 1 << 8,
  WaterJump = 1 << 9,
  TeamSlave = 1 << 10,
  NoKnockback = 1 << 11,
  PowerArmor = 1 << 12,

  // Rogue / Rerelease
  Mechanical = 1 << 13,
  SamRaimi = 1 << 14,
  Disguised = 1 << 15,
  NoGib = 1 << 16,
  Damageable = 1 << 17,
  Stationary = 1 << 18,

  AliveKnockbackOnly = 1 << 19,
  NoDamageEffects = 1 << 20,
  CoopHealthScale = 1 << 21,
  Flashlight = 1 << 22,
  KillVelocity = 1 << 23,
  NoVisible = 1 << 24,
  Dodge = 1 << 25,
  TeamMaster = 1 << 26,
  Locked = 1 << 27,
  AlwaysTouch = 1 << 28,
  NoStanding = 1 << 29,
  WantsPowerArmor = 1 << 30,
  Respawn = 1 << 31,
}

export enum EntityEffects {
  Rotate = 1 << 0,
  Gib = 1 << 1,
  Bob = 1 << 2, // Rerelease insertion
  Blaster = 1 << 3,
  Rocket = 1 << 4,
  Grenade = 1 << 5,
  HyperBlaster = 1 << 6,
  Bfg = 1 << 7,
  ColorShell = 1 << 8,
  PowerScreen = 1 << 9,
  Anim01 = 1 << 10,
  Anim23 = 1 << 11,
  AnimAll = 1 << 12,
  AnimAllFast = 1 << 13,
  Flies = 1 << 14,
  Quad = 1 << 15,
  Pent = 1 << 16,
  Teleporter = 1 << 17,
  Flag1 = 1 << 18,
  Flag2 = 1 << 19,
  IonRipper = 1 << 20,
  GreenGib = 1 << 21,
  BlueHyperBlaster = 1 << 22,
  SpinningLights = 1 << 23,
  Plasma = 1 << 24,
  Trap = 1 << 25,
  Tracker = 1 << 26,
  Double = 1 << 27,
  SphereTrans = 1 << 28,
  TagTrail = 1 << 29,
  HalfDamage = 1 << 30,
  TrackerTrail = 1 << 31,

  // Extended flags placeholders (requires >32 bit support or mapping)
  Hologram = 0,
  Flashlight = 0,
}

export enum MuzzleFlash {
    Blaster = 0,
    MachineGun = 1,
    Shotgun = 2,
    Chaingun1 = 3,
    Chaingun2 = 4,
    Chaingun3 = 5,
    Railgun = 6,
    Rocket = 7,
    Grenade = 8,
    Login = 9,
    Logout = 10,
    Respawn = 11,
    Bfg = 12,
    SShotgun = 13,
    HyperBlaster = 14,
    ItemRespawn = 15,
    IonRipper = 16,
    BlueHyperBlaster = 17,
    Phalanx = 18,
    Bfg2 = 19,
    Phalanx2 = 20,
    EtfRifle = 30,
    Prox = 31,
    EtfRifle2 = 32,
    HeatBeam = 33,
    Blaster2 = 34,
    Tracker = 35,
    Nuke1 = 36,
    Nuke2 = 37,
    Nuke4 = 38,
    Nuke8 = 39,

    // Rogue / MZ2
    TankBlaster1 = 1, // These are MZ2 indices, likely passed differently or offset
    // For now assuming we pass them as-is if the engine handles it.
    // Actually the engine takes a `flashtype` index which maps to `monster_flash_offset` array in C.
    // In TS we likely need to handle this mapping or pass the index.
    // I'll add the ones needed for Carrier with assumed indices.

    // Carrier
    CarrierMachineGunL1 = 133,
    CarrierMachineGunR1 = 134,
    CarrierGrenade = 135,
    CarrierRailgun = 147,
    CarrierMachineGunL2 = 152,
    CarrierMachineGunR2 = 153,
    CarrierRocket1 = 191,
    CarrierRocket2 = 192,
    CarrierRocket3 = 193,
    CarrierRocket4 = 194,

    // Gunner
    GunnerGrenade1 = 53,
}
